import type { ReactNode } from 'react'
import { createPortal } from 'react-dom'
import { useContentHeaderActions } from '../AdminLayout/adminLayoutContext'

type OverTheTopSectionProps = {
  children: ReactNode
}

export const OverTheTopSection = ({ children }: OverTheTopSectionProps) => {
  const headerActions = useContentHeaderActions()

  if (headerActions?.slot) {
    return createPortal(children, headerActions.slot)
  }

  return <div className='flex justify-end'>{children}</div>
}
